import React, { Component } from "react";
import BoatListAll from "./BoatList/BoatListAll";
import { Dataprovider } from "./BoatStore/BoatData";

export default class BoatList extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
        <Dataprovider {...this.props}>
          <BoatListAll {...this.props} />
        </Dataprovider>
      </>
    );
  }
}
